module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("为了保障您的索赔权益，请确认你符合以下索赔范围并登记（可多选）：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.claimStep1
    }
  }, [_vm._v("我要索赔登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_a"
  }, [_c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question1"
    }
  }), _vm._v("商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question2"
    }
  }), _vm._v("商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question3"
    }
  }), _vm._v("商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question4"
    }
  }), _vm._v("商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question5"
    }
  }), _vm._v("商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad28b82a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/claimStep1.vue
// module id = 844
// module chunks = 1